module.exports = __webpack_public_path__ + "pSIbFAhLWaWz2Kf3O/icon-lightbulb.svg";